export const ROLE_OPTIONS = [
  {
    value: 'admin',
    label: 'Administrador',
    shortLabel: 'AD',
    sub: 'Gestor da conta',
    summary: 'Acesso total à operação, equipe, integrações e administração.',
    tone: { bg: 'rgba(29, 45, 61, 0.12)', border: 'rgba(29, 45, 61, 0.18)', color: '#1d2d3d' },
  },
  {
    value: 'pilot',
    label: 'Piloto',
    shortLabel: 'PI',
    sub: 'Operador em voo',
    summary: 'Acessa a operação e registros próprios para planejar, executar e fechar voos.',
    tone: { bg: 'rgba(65, 97, 128, 0.12)', border: 'rgba(65, 97, 128, 0.18)', color: '#416180' },
  },
  {
    value: 'mechanic',
    label: 'Mecânico',
    shortLabel: 'ME',
    sub: 'Manutenção',
    summary: 'Foco em aeronaves, manutenção, documentos técnicos, logbook e combustível.',
    tone: { bg: 'rgba(122, 122, 125, 0.12)', border: 'rgba(122, 122, 125, 0.18)', color: '#7a7a7d' },
  },
  {
    value: 'finance',
    label: 'Financeiro',
    shortLabel: 'FI',
    sub: 'Custos e conciliação',
    summary: 'Acompanha custos, combustível, prestação de contas, orçamento e relatórios.',
    tone: { bg: 'rgba(65, 97, 128, 0.12)', border: 'rgba(65, 97, 128, 0.18)', color: '#416180' },
  },
  {
    value: 'analyst',
    label: 'Analista',
    shortLabel: 'AN',
    sub: 'Análise e governança',
    summary: 'Lê dados operacionais, safety e financeiros para análise e auditoria.',
    tone: { bg: 'rgba(152, 152, 155, 0.18)', border: 'rgba(152, 152, 155, 0.2)', color: '#416180' },
  },
  {
    value: 'secretary',
    label: 'Secretaria',
    shortLabel: 'SE',
    sub: 'Apoio operacional',
    summary: 'Coordena agenda, passageiros, contatos, documentos e suporte administrativo.',
    tone: { bg: 'rgba(93, 93, 96, 0.12)', border: 'rgba(93, 93, 96, 0.18)', color: '#5d5d60' },
  },
  {
    value: 'safety_officer',
    label: 'Oficial de Safety',
    shortLabel: 'SO',
    sub: 'Governança SGSO',
    summary: 'Revisa evidências, governa riscos e valida o encerramento de ações de Safety.',
    tone: { bg: 'rgba(29, 31, 32, 0.10)', border: 'rgba(29, 31, 32, 0.20)', color: '#1d1f20' },
  },
  {
    value: 'accountable_manager',
    label: 'Gestor Responsável',
    shortLabel: 'GR',
    sub: 'Autoridade executiva do SGSO',
    summary: 'Aceita riscos críticos e exerce a autoridade final prevista na política de Safety.',
    tone: { bg: 'rgba(66, 66, 68, 0.10)', border: 'rgba(66, 66, 68, 0.22)', color: '#2b2b2d' },
  },
  {
    value: 'medical_reviewer',
    label: 'Revisor Médico',
    shortLabel: 'RM',
    sub: 'Saúde da tripulação',
    summary: 'Revisa aptidão e sinais de fadiga com acesso restrito aos dados necessários.',
    tone: { bg: 'rgba(65, 97, 128, 0.12)', border: 'rgba(65, 97, 128, 0.22)', color: '#416180' },
  },
];

export const ROLE_ACCESS_NONE = 'none';

export const ROLE_ACCESS_LEVELS = [
  {
    id: 'full',
    label: 'Total',
    shortLabel: 'T',
    color: '#2c455d',
    bg: 'rgba(44, 69, 93, 0.12)',
    border: 'rgba(44, 69, 93, 0.24)',
    description: 'Página disponível para o perfil com o escopo completo previsto para a função.',
  },
  {
    id: 'own',
    label: 'Próprios dados',
    shortLabel: 'P',
    color: '#98989b',
    bg: 'rgba(152, 152, 155, 0.14)',
    border: 'rgba(152, 152, 155, 0.26)',
    description: 'Página disponível com escopo limitado aos próprios voos, registros ou tarefas.',
  },
  {
    id: 'governance',
    label: 'Governança',
    shortLabel: 'G',
    color: '#5d5d60',
    bg: 'rgba(93, 93, 96, 0.13)',
    border: 'rgba(93, 93, 96, 0.25)',
    description: 'Página disponível para leitura, revisão, auditoria ou aprovação de governança.',
  },
  {
    id: ROLE_ACCESS_NONE,
    label: 'Sem acesso',
    shortLabel: '—',
    color: '#5d5d60',
    bg: 'rgba(93, 93, 96, 0.08)',
    border: 'rgba(93, 93, 96, 0.22)',
    description: 'Página ocultada da navegação e bloqueada em acesso direto quando a rota usa V2.',
  },
];

const F = 'full';
const O = 'own';
const G = 'governance';
const N = ROLE_ACCESS_NONE;

const byRole = (admin, pilot, mechanic, finance, analyst, secretary) => ({
  admin,
  pilot,
  mechanic,
  finance,
  analyst,
  secretary,
});

export const ROLE_PAGE_ACCESS = {
  'v2-home': byRole(F, F, F, F, F, F),
  'v2-flights': byRole(F, O, F, O, F, F),
  'v2-aircraft': byRole(F, O, F, O, F, F),
  'v2-pilots': byRole(F, O, N, N, F, F),
  'v2-passenger-history': byRole(F, O, N, O, F, F),
  'v2-contacts': byRole(F, O, N, N, F, F),
  'v2-operations-docs': byRole(F, O, F, F, F, F),
  'v2-contracts': byRole(F, N, N, F, F, F),
  'v2-chartered': byRole(F, O, N, F, F, F),
  'v2-safety-center': byRole(F, O, N, N, G, N),
  'v2-safety-flow': byRole(F, O, N, N, G, N),
  'v2-frat': byRole(F, O, N, N, G, N),
  'v2-tem': byRole(F, O, N, N, G, N),
  'v2-fdm': byRole(F, O, N, N, G, N),
  'v2-risk-matrix': byRole(F, O, O, N, G, N),
  'v2-hazard-approvals': byRole(F, N, N, N, N, N),
  // Confidential reporting intake (14 CFR 5.71(a)(7)): every role must be able
  // to report — a mechanic or ramp-facing employee is exactly who the rule
  // protects. Kept in sync with api/rbac/seed.py by test_rbac_catalog_sync.
  'v2-confidential-report': byRole(F, O, O, O, O, O),
  // Triage queue mirrors hazard approvals: Safety authority only.
  'v2-confidential-reports': byRole(F, N, N, N, N, N),
  'v2-safety-audit': byRole(F, N, N, N, G, N),
  'v2-safety-assessment': byRole(F, O, N, N, G, N),
  'v2-erp': byRole(F, O, F, O, G, F),
  'v2-mission-control': byRole(F, O, F, O, F, F),
  'v2-edb-closeout': byRole(F, O, F, N, F, N),
  'v2-logbook': byRole(F, O, F, N, F, N),
  'v2-flight-logs': byRole(F, O, F, N, N, N),
  'v2-flight-debrief': byRole(F, O, N, N, G, F),
  'v2-fuel-entry': byRole(F, O, F, F, N, N),
  'v2-unified-fuel-entry': byRole(F, O, F, F, N, N),
  'v2-flight-costs': byRole(F, O, N, F, F, N),
  'v2-passenger-ratings': byRole(F, O, N, N, F, F),
  'v2-financeiro': byRole(F, O, N, F, G, N),
  'v2-safety-analysis': byRole(F, O, N, N, G, N),
  'v2-fuel-analyzer': byRole(F, N, F, F, F, N),
  'v2-fixed-costs': byRole(F, N, N, F, F, N),
  'v2-variable-costs': byRole(F, N, N, F, F, N),
  'v2-prestacao-contas': byRole(F, O, N, F, F, F),
  'v2-budget': byRole(F, N, N, F, F, N),
  'v2-cost-intelligence': byRole(F, N, N, F, F, N),
  'v2-accumulated-intelligence': byRole(F, N, N, N, N, N),
  // A autorização efetiva desta rota é a allowlist permanente definida em
  // operationalAssuranceAccess; a matriz existe para manter os catálogos sync.
  'v2-ai-agents-quality': byRole(F, N, N, N, F, N),
  'v2-audit-report': byRole(F, N, N, F, G, N),
  'v2-whatsapp-test': byRole(F, N, N, N, N, N),
  'v2-settings-team': byRole(F, N, N, N, N, N),
  'v2-billing': byRole(F, N, N, N, N, N),
  'v2-admin-billing': byRole(F, N, N, N, N, N),
  'v2-admin-notifications': byRole(F, N, N, N, N, N),
  'v2-admin-email-integrations': byRole(F, N, N, N, N, N),
  'v2-admin-whatsapp-mission': byRole(F, N, N, N, N, N),
  'v2-admin-lgpd': byRole(F, N, N, N, N, N),
  'v2-admin-company-goals': byRole(F, N, N, N, N, N),
  'v2-admin-ai-feedback': byRole(F, N, N, N, N, N),
  'v2-admin-ai-cost': byRole(F, N, N, N, N, N),
  'v2-admin-account-usage': byRole(F, N, N, N, N, N),
  'v2-admin-assistant-lessons': byRole(F, N, N, N, N, N),
  'v2-admin-nod-rollout-readiness': byRole(F, N, N, N, N, N),
  'v2-admin-owner': byRole(F, N, N, N, N, N),
  'v2-admin-waitlist': byRole(F, N, N, N, N, N),
  'v2-admin-vip-invites': byRole(F, N, N, N, N, N),
};

const SAFETY_OFFICER_GOVERNANCE_PAGES = new Set([
  'v2-safety-center',
  'v2-frat',
  'v2-tem',
  'v2-fdm',
  'v2-risk-matrix',
  'v2-hazard-approvals',
  'v2-safety-audit',
  'v2-safety-assessment',
  'v2-safety-flow',
  'v2-safety-analysis',
  'v2-erp',
  'v2-flight-debrief',
  'v2-audit-report',
]);
const SAFETY_OFFICER_OWN_PAGES = new Set([
  'v2-home',
  'v2-flights',
  'v2-aircraft',
  'v2-mission-control',
]);
const MEDICAL_REVIEWER_OWN_PAGES = new Set(['v2-home', 'v2-pilots']);

// Keep the offline fallback aligned with the backend's seeded extended roles.
// Tenant-provided accessMap values remain authoritative at runtime.
Object.entries(ROLE_PAGE_ACCESS).forEach(([pageId, access]) => {
  access.safety_officer = SAFETY_OFFICER_GOVERNANCE_PAGES.has(pageId)
    ? G
    : SAFETY_OFFICER_OWN_PAGES.has(pageId) ? O : N;
  access.accountable_manager = SAFETY_OFFICER_GOVERNANCE_PAGES.has(pageId)
    ? G
    : SAFETY_OFFICER_OWN_PAGES.has(pageId) ? O : N;
  access.medical_reviewer = MEDICAL_REVIEWER_OWN_PAGES.has(pageId) ? O : N;
});

export function normalizeRole(role) {
  return String(role || '').trim().toLowerCase();
}

export function getRoleInfo(role) {
  const normalized = normalizeRole(role);
  return ROLE_OPTIONS.find((item) => item.value === normalized) || {
    value: normalized,
    label: role || 'Perfil',
    shortLabel: String(role || '??').slice(0, 2).toUpperCase(),
    sub: 'Perfil não mapeado',
    summary: 'Perfil sem matriz definida.',
    tone: { bg: '#f5f5f8', border: '#d6ebff', color: '#5d5d60' },
  };
}

export function getRoleAccessLevelInfo(level) {
  return ROLE_ACCESS_LEVELS.find((item) => item.id === level) || ROLE_ACCESS_LEVELS.at(-1);
}

export function getRoleAccessForPage(pageId, role, accessMap = null) {
  if (accessMap && Object.prototype.hasOwnProperty.call(accessMap, pageId)) {
    return accessMap[pageId];
  }
  if (accessMap) return ROLE_ACCESS_NONE; // authoritative map: unknown key = none
  return ROLE_PAGE_ACCESS[pageId]?.[normalizeRole(role)] || ROLE_ACCESS_NONE;
}

export function roleCanAccessPage(pageId, role, accessMap = null) {
  return getRoleAccessForPage(pageId, role, accessMap) !== ROLE_ACCESS_NONE;
}
